import { FlashFilled } from '@carbon/icons-react';
import { Sparkle } from '@routable/ai';
import { Tooltip } from '@routable/gross-ds';
import React from 'react';
import { useOverlaysSourceForFieldValue } from 'hooks';
const InputLabel = ({ hideLabel, isRequired, label, name, placeholder, value }) => {
    const { currentSource, isPredictiveCodingUiEnabled } = useOverlaysSourceForFieldValue(name);
    if (hideLabel || (!label && !value)) {
        return null;
    }
    const labelValue = label || placeholder;
    return (React.createElement("label", { className: "inline-flex gap-2", htmlFor: name },
        currentSource && (React.createElement(Tooltip, { "data-testid": `source-tooltip-${name}`, tooltip: isPredictiveCodingUiEnabled && currentSource, variant: "dark" }, isPredictiveCodingUiEnabled ? (React.createElement(Sparkle, { size: 12 })) : (React.createElement(FlashFilled, { className: "text-magenta-50", size: 12, title: "OCR" })))),
        labelValue,
        isRequired && React.createElement("span", null, ' *')));
};
export default InputLabel;
